import { lazy } from "react";

export { WORK_CONDITIONS_CHANGE_REQUESTS_PATH } from "./path";
export const WorkConditionsChangeRequestsPage = lazy(() => import("./page"));
